class LocationClient {
  async getLocation(nested) {
    throw new Error("getWallboxes method must be implemented");
  }

  async getWallboxes(nested) {
    throw new Error("getWallboxes method must be implemented");
  }

  async getWallbox(wallboxId, nested) {
    throw new Error("getWallbox method must be implemented");
  }

  async putWallbox(id, data) {
    throw new Error("putWallbox method must be implemented");
  }

  async putWallboxSetPoint(id, data) {
    throw new Error("putWallboxSetPoint method must be implemented");
  }

  async addWallboxLockTime(data) {
    throw new Error("addWallboxLockTime method must be implemented");
  }

  async deleteWallboxLockTime(id) {
    throw new Error("deleteWallboxLockTime method must be implemented");
  }

  async getHeatpumps(nested) {
    throw new Error("getHeatpumps method must be implemented");
  }

  async putHeatpump(id, data) {
    throw new Error("putHeatpump method must be implemented");
  }

  async putHeatpumpSetPoint(id, data) {
    throw new Error("putHeatpumpSetPoint method must be implemented");
  }

  async getFlow() {
    throw new Error("getFlow method must be implemented");
  }

  async getSgReadyHistory(params = {}) {
    throw new Error("getSgReadyHistory method must be implemented");
  }

  async getChargingHistory(params = {}) {
    throw new Error("getChargingHistory method must be implemented");
  }

  async getChargingHistoryStats(params = {}) {
    throw new Error("getChargingHistoryStats method must be implemented");
  }

  async getHourlyFlow(params = {}) {
    throw new Error("getHourlyFlow method must be implemented");
  }

  async getDailyFlow(params = {}) {
    throw new Error("getDailyFlow method must be implemented");
  }

  async getMonthlyFlow(params = {}) {
    throw new Error("getMonthlyFlow method must be implemented");
  }
}

export default LocationClient;
